<template>
  <div class="content">
    <div class="subcontent">
      <h1>Basic Text Area</h1>
    </div>
    <div>
      <select v-model="currentTextName" @change="changeTextName">
        <option v-for="tn in textNames" :key="tn" :value="tn">
          {{ tn }}
        </option>
      </select>
    </div>
    <div class="subcontent">
      <textarea
        class="box"
        name="text"
        v-model="value"
        @input="changeValue"
      ></textarea>
    </div>
    <div class="subcontent">
      <button class="button button-clear" @click="clear()">CLEAR</button>
      <button class="button button-copy" @click="copy()">COPY</button>
    </div>
    <div class="subcontent" v-if="showDelete">
      <button class="button button-clear" @click="deleteTab()">DELETE</button>
    </div>
    <div>Characters count: {{ charactersCount }}</div>
  </div>
</template>

<script>
import api from "../../api/api";

export default {
  data() {
    return {
      value: "",
      textNames: [],
      currentTextName: "",
    };
  },
  async created() {
    await this.init();
  },
  computed: {
    charactersCount() {
      return this.value.length;
    },
    currentRoute() {
      const path = this.$route.path || "/";
      return path.substring(1);
    },
    showDelete() {
      const lower = this.currentTextName.toLowerCase();
      return lower !== "" && lower !== "ben" && lower !== "caro";
    },
  },
  methods: {
    async init() {
      this.textNames = await this.getTexts();
      const foundTextName = this.textNames.find(
        (tn) => tn.toLowerCase() === this.currentRoute
      );
      if (this.currentRoute.length === 0) {
        this.currentTextName = this.textNames[0];
      } else if (foundTextName) {
        this.currentTextName = foundTextName;
      } else {
        this.textNames.push(this.currentRoute)
        this.currentTextName = this.currentRoute;
        await this.updateText();
        this.textNames = await this.getTexts();
      }
      await this.getCurrentValue();
    },
    async getTexts() {
      return (await api.getTexts()).data;
    },
    async getCurrentValue() {
      this.value = (await api.getText(this.currentTextName)).data;
    },
    async changeValue() {
      await this.updateText();
    },
    async changeTextName() {
      if (!this.currentTextName) return;
      this.$router.push({ path: `/${this.currentTextName.toLowerCase()}` });
      await this.getCurrentValue();
    },
    async updateText() {
      await api.updateText(this.currentTextName, this.value);
    },
    async clear() {
      this.value = "";
      await this.updateText();
    },
    copy() {
      this.$copyText(this.value);
    },
    async deleteTab() {
      await api.deleteTab(this.currentTextName);
      this.currentTextName = this.textNames[0];
      this.$router.push({ path: `/${this.currentTextName.toLowerCase()}` });
      await this.init();
    },
  },
};
</script>

<style>
body {
  background-color: black;
  color: #cfcfcf;
  font-family: Tahoma, sans-serif;
  padding: 0 1em;
}

.content {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.subcontent {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  width: 100%;
  max-width: 800px;
  min-height: 300px;
  background-color: black;
  color: #cfcfcf;
  box-sizing: border-box;
  font-size: 15px;
}

.button {
  width: 200px;
  height: 50px;
  margin: 10px 10px;
  background: none;
  border: 1px solid rgb(83, 83, 83);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  transition: background-color 0.25s ease;
}

.button:hover {
  cursor: pointer;
}

.button:focus {
  outline: 0;
}

.button-copy:hover {
  background-color: rgb(0, 99, 30);
}

.button-clear:hover {
  background-color: rgb(99, 0, 0);
}

textarea:focus {
  outline: 0;
}

select {
  background: #000;
  color: #fff;
  padding: 8px 28px 8px 10px;
  margin-bottom: 10px;
  outline: none;
  box-shadow: none;
}
</style>
